import { Component, OnInit, Inject, Input, AfterViewInit, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { ScheduleService } from '../schedule.service';
import { ScheduleJob } from '../schedulejob';
import { Observable, of } from 'rxjs';
import { tap, map, catchError } from 'rxjs/operators';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessagerComponent } from '../../messager/messager/messager.component';
import { FormBuilder } from '@angular/forms';
import * as moment from 'moment';
import { RaterFormService } from 'src/app/raterform/raterform.service';
import { CHECKLIST_ITEMS } from 'backend/utility/checklist.constant';
import { PhotoViewerDialogComponent } from 'src/app/raterform/photo-viewer-dialog.component';

declare var google: any;

@Component({
  selector: 'app-rating-photos-dialog',
  templateUrl: './rating-photos.html',
  styleUrls: ['../schedule/schedule.component.css', './rating-photos.css']

})

export class RatingPhotosDialogComponent implements OnInit, AfterViewInit {

  @ViewChild('mapContainer', {static: false}) mapContainer: ElementRef;
  latitude: number = 0; // Default values
  longitude: number = 0; // Default values


  photoData : any[] = [];
  elevPhotos : any[] = [];
  multifamily : any[] = [];
  esmfnc : any[] = [];
  checklistPhotosOnly : any[] = [];
  jobCondPics: any;
  selfiePhotos: any[] = [];
  selfieLoading: boolean = true;

  // Pinned header lines: "address, city" and "subdivision - Lot n". Built from data.job,
  // overridden by an optional data.location for callers whose job row lacks those columns.
  locAddress: string = '';
  locDetail: string = '';

  // Fields whose extra photos live in formpics (a row per photo). Their single "last photo" already
  // comes through data.photos (the wide locpics row); we merge the rest inline at each field's
  // natural position in the Rating Photos grid. selfie_pic + ESMFNC item% have their own sections.
  static readonly MULTI_PHOTO_FIELDS: string[] = ['loflowafx', 'vent_ctrl', 'es_ceiling_fans', 'all_otr_ceilings'];

  // Per-system HVAC grading photos (locraterf.hvacgrade JSONB). Not locpics columns, so they have no
  // natural grid position and get their own section.
  hvacGradingGroups: { label: string; photos: { url: string; label: string; exifName: string }[]; pdf: string | null }[] = [];

  isMobile: boolean = window.innerWidth < 768;
  popupIsShowing: boolean = false;
  modalImage: any;
  modalImageCaption: string = '';
  checklistItems = CHECKLIST_ITEMS;
  checklistItemFields = this.checklistItems.map(item => item.field);
  currentExifDate: string = 'Fetching EXIF...';
  currentExifLatitude: string; 
  currentExifLongitude: string;
  constructor(public cdr: ChangeDetectorRef, public dialogRef: MatDialogRef<RatingPhotosDialogComponent>, public dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any, private fb: FormBuilder, public rfservice: RaterFormService, public scheduleService: ScheduleService, private messager: MessagerComponent) {}

  mfatemplate;

  currentExifData: any = null;
  currentHoveredImage: string = '';
  hoverTimer: any = null;
  exifCache: Map<string, any> = new Map(); // Cache to avoid repeated API calls


  ngAfterViewInit() {
    this.initMap();
  }

  initMap(): void {

  }

  updateLocation(latitude: number, longitude: number) {
    this.latitude = latitude;
    this.longitude = longitude;
    this.initMap();
  }


  buildLocationHeader(): void {
    const loc: any = { ...((this.data && this.data.job) || {}), ...((this.data && this.data.location) || {}) };
    const clean = v => (v == null ? '' : v.toString().trim());
    this.locAddress = [clean(loc.street_address), clean(loc.city)].filter(Boolean).join(', ');
    const sub = clean(loc.subdivision_name);
    const lot = clean(loc.lot);
    this.locDetail = [sub, lot ? 'Lot ' + lot : ''].filter(Boolean).join(' - ');
  }

  ngOnInit(): void {

    this.buildLocationHeader();

    const esphotos = this.data.photos.filter(item => this.checklistItemFields.includes(item.name) && item.image != null);
    this.photoData = this.data.photos.sort((a, b) => a.name.toLowerCase().trim().localeCompare(b.name.toLowerCase().trim()))
    .filter(item => !this.checklistItemFields.includes(item.name))

   esphotos.forEach(item => {
    const fieldname = item.name; 
    const clitem = this.checklistItems.find(clItem => clItem.field === fieldname);
    if (clitem) {
      const field = clitem.field;
      const description = clitem.description;
      const photos = item.image ? [item.image] : [];
      // Store the original item's exif data
      this.checklistPhotosOnly.push({ 
        field, 
        description, 
        photos, 
        exif: item.exif || {},  // Add exif data
        name: item.name         // Add name for consistency
      });
    }
  });


   this.scheduleService.getElevPicsLocmain(this.data.job.location_id).subscribe(
     res =>{

      this.elevPhotos.push({'name': 'elevleft', 'image' : res.Photos.elevleft || ''});
      this.elevPhotos.push({'name': 'elevright', 'image' : res.Photos.elevright || ''});
      this.elevPhotos.push({'name': 'elevback', 'image' : res.Photos.elevback || ''});
      this.elevPhotos.push({'name': 'elevfront', 'image': res.Photos.elevfront || ''});

      this.elevPhotos.forEach(item => {
        this.data.photos.push({
          name: item.name,
          image: item.image
        });
      })

    });
   



   this.scheduleService.getRaterPicsesmfnc(this.data.job.location_id).subscribe(
    res => {
      this.esmfnc =  res.Photos?.map(item => {
        let exifparsed = item.exif.length > 0 ? JSON.parse(item.exif[0]) : {};
        item = {...item, exif: exifparsed};
        // Push multi-photos into data.photos for EXIF hover support
        if(item.photos && item.photos.length > 0) {
          item.photos.forEach((photo, i) => {
            this.data.photos.push({ name: item.name + '_photo_' + i, image: photo });
          });
        }
        return item;
      });
    }, err => {
    });

    //get job condition photos
    this.scheduleService.getJobConditionPics(this.data.job.location_id).subscribe(
      res => {
        res.Photos.map(item => {
          item.imgref = 'https://inspexn.s3.us-east-1.amazonaws.com/' + item.imgref;
          item.key = item.caption;
        });
        this.jobCondPics = res.Photos;
      });

    this.scheduleService.getSelfiePic(this.data.job.location_id).subscribe(
      res => {
        if(res.Photos && res.Photos.length > 0){
          this.selfiePhotos = res.Photos.map((pic, i) => {
            pic.name = 'selfie_' + i;
            this.data.photos.push({ name: pic.name, image: pic.image_url });
            return pic;
          });
        }
        this.selfieLoading = false;
      }, err => {
        this.selfieLoading = false;
      }
    );

    // Merge every formpics row for each multi-photo field into that field's item in the grid, so all
    // of its photos render inline at the field's natural (sorted) position — not just the last one.
    if (this.data.job.form_id) {
      RatingPhotosDialogComponent.MULTI_PHOTO_FIELDS.forEach(field => {
        let item = this.photoData.find(p => p.name === field);
        const photos: string[] = [];
        if (item && item.image) { photos.push(item.image); }

        this.rfservice.getFormPics(this.data.job.form_id, field).subscribe(
          res => {
            if (!res.Error && res.Rows > 0) {
              res.Photos.forEach(photo => {
                if (photo.image_url && !photos.includes(photo.image_url)) {
                  photos.push(photo.image_url);
                }
              });
            }
            if (!photos.length) { return; }
            // If locpics never held a single for this field, add an item so it still appears at its
            // sorted spot in the grid.
            if (!item) {
              item = { name: field, image: photos[0] };
              this.photoData.push(item);
              this.photoData.sort((a, b) => a.name.toLowerCase().trim().localeCompare(b.name.toLowerCase().trim()));
            }
            item.photos = photos;
            // Register each photo's name so the EXIF hover + Map button resolve it.
            photos.forEach((url, i) => {
              const exifName = field + '_photo_' + i;
              if (!this.data.photos.some(p => p.name === exifName)) {
                this.data.photos.push({ name: exifName, image: url });
              }
            });
          },
          _err => {}
        );
      });
    }

    // Per-system HVAC grading photos live in the locraterf.hvacgrade JSONB (system1..4). These aren't
    // locpics columns, so they render in their own section rather than inline in the grid.
    if (this.data.job.form_id) {
      this.scheduleService.getDataByFormID(this.data.job.form_id).subscribe(
        res => {
          const hvacgrade = res && res.formData ? res.formData.hvacgrade : null;
          if (!hvacgrade) { return; }
          const imageFields = [
            { key: 'voltsPhoto', label: 'Volts' },
            { key: 'ampsPhoto', label: 'Amps' },
            { key: 'linesetPhoto', label: 'Lineset' },
          ];
          for (let s = 1; s <= 4; s++) {
            const sys = hvacgrade['system' + s];
            if (!sys) { continue; }
            const label = (sys.name && ('' + sys.name).trim().length) ? ('' + sys.name).trim() : ('System ' + s);
            const photos: { url: string; label: string; exifName: string }[] = [];
            imageFields.forEach(f => {
              const url = sys[f.key];
              if (url && typeof url === 'string') {
                const exifName = 'system' + s + '_' + f.key;
                photos.push({ url, label: label + ' ' + f.label, exifName });
                if (!this.data.photos.some(p => p.name === exifName)) {
                  this.data.photos.push({ name: exifName, image: url });
                }
              }
            });
            const pdf = (sys.airflowReport && typeof sys.airflowReport === 'string') ? sys.airflowReport : null;
            if (photos.length || pdf) {
              this.hvacGradingGroups.push({ label, photos, pdf });
            }
          }
        },
        _err => {}
      );
    }

    this.scheduleService.getESChecklistPics(this.data.job.location_id).subscribe(
      res => {
        for(let i=0; i < res.Photos.length; i++) {
          const fieldname = res.Photos[i].field_name;
          let item = this.checklistPhotosOnly.find(item => item.field === fieldname);
          if (item) { 
            if(!item.photos.includes(res.Photos[i].image_url)) {
              item.photos.push(res.Photos[i].image_url);
            }
          }
        }

      }
    );
    


     if(this.data.mftemplate != null) {

      this.scheduleService.getMFtemplate(this.data.mftemplate).subscribe(
        res => {
          this.mfatemplate = res.Response;
          //grab the photos
          this.scheduleService.getMFpictures(this.data.job_id).subscribe(
            res => {
              this.multifamily = res.Response.map(item => {
                if (item.image && item.image.endsWith('_pic_pic.jpg')) {
                  item.image = item.image.replace('_pic_pic.jpg', '_pic.jpg');
                }

                if (item.fieldname && item.fieldname.startsWith('field')) {
                  const fieldIndex = parseInt(item.fieldname.replace('field', ''), 10);
                  if (fieldIndex < this.mfatemplate.fields.length) {
                    item.fieldname = this.mfatemplate.fields[fieldIndex + 1].descr;
                  }
                }
                return item;
              });
            }, err => {});
        }, err => {});

     }
    }

    display(item: any): string{
      const display=item?.exif?.Exif && (typeof item?.exif?.Exif === 'object') && !Array.isArray(item?.exif?.Exif) &&  Object.keys(item?.exif?.Exif).length > 0
      if(display){
      return 'flex'
      }else {
        return 'none';
      }
    }


  onImageHover(imageName: string) {
    if (this.hoverTimer) {
      clearTimeout(this.hoverTimer);
    }

    this.currentHoveredImage = imageName;

    if (this.exifCache.has(imageName)) {
      this.currentExifData = this.exifCache.get(imageName);
      this.updateExifDisplay();
      this.hoverTimer = null; 
    }else{
      this.hoverTimer = setTimeout(() => {
        this.loadExifData(imageName);
        this.cdr.detectChanges(); 
      }, 1000);
    }

  }

  onImageLeave() {
    if (this.hoverTimer) {
      clearTimeout(this.hoverTimer);
      this.hoverTimer = null;
    }
    
    this.currentHoveredImage = '';
    this.clearExifDisplay();
    this.cdr.detectChanges(); 
  }

  updateExifDisplay() {
    this.currentExifDate = this.dateHandler(this.currentExifData);
    this.currentExifLatitude = this.latitudeHandler(this.currentExifData);
    this.currentExifLongitude = this.longitudeHandler(this.currentExifData);
    this.cdr.detectChanges();
  } 

  clearExifDisplay() {
    this.currentExifDate = 'Loading EXIF...';
    this.currentExifLatitude = '';
    this.currentExifLongitude = '';
    this.currentExifData = null;
  }

  loadExifData(imageName: string) {

    try {
      // Extract image name from URL (same logic as your original code)
      const photoObj = this.data.photos.find(photo => photo.name === imageName);
      if (!photoObj || !photoObj.image || typeof photoObj.image !== 'string') {
        return;
      }

      const imageUrl = photoObj.image;

      const imgParts = imageUrl.split('com/');
      if (imgParts.length > 1) {
        const img1 = imgParts[1].split('.');
        const imageNameForQuery = img1[0];

        this.scheduleService.getExifData(imageNameForQuery).subscribe(
          res =>{
            if (res && res.exif.length > 0) {
              this.currentExifData = JSON.parse(res.exif);
              this.exifCache.set(imageName, this.currentExifData);
              this.updateExifDisplay();
            }else{
              this.clearExifDisplay();
            }
          }
          )
      }

      
    } catch (error) {
      this.clearExifDisplay();
    }

  }


    dateHandler(item: any): string {
  
      // List of EXIF tags that might contain the date 
      const dateTags = [
        { key: '36867', parent: 'Exif' },
        { key: '36868', parent: 'Exif' },
        { key: '306', parent: '0th' },
      ];

      // Finds the first tag with a non-null value
      const date = dateTags.reduce((acc, { key, parent }) => {
        const parentObj = item?.[parent];
        const value = parentObj?.[key];
    
        if (acc) return acc; 
    
        return (value && !Array.isArray(value) && value) ? value : null;
      }, null);
  
      return date ? moment(date, 'YYYY:MM:DD HH:mm:ss').format('MM-DD-YYYY HH:mm:ss') : '(No Date found)';
    }

  latitudeHandler(item: any): string {
    const latitude=item?.GPS && (typeof item?.GPS === 'object') && !Array.isArray(item?.GPS) &&  Object.keys(item?.GPS).length > 0 ?item?.GPS :null
    if(latitude && latitude[2] && latitude[2][0] && latitude[2][1] && latitude[2][2]){
      let lat = `${latitude[2][0][0]/latitude[2][0][1]} deg ${latitude[2][1][0]/latitude[2][1][1]}'  ${latitude[2][2][0]/latitude[2][2][1]}" ${latitude[1]}`
      return lat;
    }
    return 'No Latitude data';
  }

  longitudeHandler(item: any): string {
    const longitude = item?.GPS && (typeof item?.GPS === 'object') && !Array.isArray(item?.GPS) &&  Object.keys(item?.GPS).length > 0 ? item?.GPS : null;
    if(longitude && longitude[4] && longitude[4][0] && longitude[4][1] && longitude[4][2]){
      return `${longitude[4][0][0]/longitude[4][0][1]} deg ${longitude[4][1][0]/longitude[4][1][1]}'  ${longitude[4][2][0]/longitude[4][2][1]}" ${longitude[3]}`;
    }
    return 'No Longitude data';
  }

  altitudeHandler(exifData: any): string {
    const altitudeRef = exifData?.GPS?.['5'] === 0 ? 'Above Sea Level' : 'Below Sea Level'; // 0 is above sea level, 1 is below
    const altitude = exifData?.GPS?.['6'];
    
    if (Array.isArray(altitude)) {
      const altitudeValue = altitude[0] / altitude[1];
      return `${altitudeValue}m ${altitudeRef}`;
    }
    
    return 'No Altitude';
  }

  private toDecimalDegrees(ref: string, dms: any[]): number | null {
    if(!dms || dms.length < 3) return null;

    const deg = (dms[0]?.[0] ?? 0) / (dms[0]?.[1] ?? 1);
    const min = (dms[1]?.[0] ?? 0) / (dms[1]?.[1] ?? 1);
    const sec = (dms[2]?.[0] ?? 0) / (dms[2]?.[1] ?? 1);

    if (!isFinite(deg) || !isFinite(min) || !isFinite(sec)) return null;

    let dec = deg + (min / 60) + (sec / 3600);
    
    if (ref === 'S' || ref === 'W') dec = -dec;

    return dec;
  }

   private getLatLngFromExif(exif: any): { lat: number, lng: number } | null {
    const gps = exif?.GPS;
    if (!gps) return null;

    const latRef = gps[1]; 
    const latDms = gps[2]; 
    const lngRef = gps[3]; 
    const lngDms = gps[4]; 

    const lat = this.toDecimalDegrees(latRef, latDms);
    const lng = this.toDecimalDegrees(lngRef, lngDms);

    if (lat == null || lng == null) return null;
    return { lat, lng };
  }

   private fetchExifForImageName(imageName: string): Observable<any | null> {
    if (this.exifCache.has(imageName)) {
      return of(this.exifCache.get(imageName));
    }

    const photoObj = this.data.photos.find(p => p.name === imageName);
    if (!photoObj || !photoObj.image || typeof photoObj.image !== 'string') {
      return of(null);
    }

    const imageUrl = photoObj.image;
    const imgParts = imageUrl.split('com/');
    if (imgParts.length <= 1) return of(null);

    const img1 = imgParts[1].split('.');
    const imageNameForQuery = img1[0];

    return this.scheduleService.getExifData(imageNameForQuery).pipe(
      map((res: any) => {
        if (res && res.exif && res.exif.length > 0) {
          const parsed = JSON.parse(res.exif);
          this.exifCache.set(imageName, parsed);
          return parsed;
        }
        return null;
      }),
      catchError(() => of(null))
    );
  }

   openMapForImage(imageName: string, imageUrl: string, caption: string) {
    this.fetchExifForImageName(imageName).subscribe(exif => {
      if (!exif) {
       this.messager.openSnackBar('No GPS coordinates found for this photo.', 'Close', 'Error');
        return;
      }

      const latlng = this.getLatLngFromExif(exif);
      if (!latlng) {
        this.messager.openSnackBar('No GPS coordinates found for this photo.', 'Close', 'Error');
        return;
      }

      // Open the location directly in Google Maps (no Static Maps API call)
      window.open(`https://www.google.com/maps?q=${latlng.lat},${latlng.lng}`, '_blank', 'noopener');
    });
  }
  


  openBigModal(image, key, index) {
    if (!image) { return; }

    this.dialog.open(PhotoViewerDialogComponent, {
      data: { url: image },
      width: '100vw',
      maxWidth: '100vw',
      height: '100dvh',
      maxHeight: '100dvh',
      panelClass: 'photo-viewer-panel',
      backdropClass: 'photo-viewer-backdrop',
    });
  }

  showDialog(image, key) {
    this.popupIsShowing = true; 
    this.modalImage = image;
    this.modalImageCaption = key;

    const modal = document.getElementById('pictureModal');
    if(modal){
      modal.style.display = 'block';
    }

  }

  closeModal(event: MouseEvent) {
    const modal = document.getElementById('pictureModal');
    if (!modal) return;
    if (event.target === modal) {
        modal.style.display = 'none';
    }
  }

  get hasAirflowReports(): boolean {
    return this.hvacGradingGroups.some(g => !!g.pdf);
  }

  close(): void {
    this.dialogRef.close();
  }



}


@Component({
  templateUrl: './view-image.html'
})
export class BigModalDialogComponent implements OnInit {

  constructor(public dref: MatDialogRef<BigModalDialogComponent>,  @Inject(MAT_DIALOG_DATA) public data:any){}

  photoArray : [];


  ngOnInit()
  {
  }


  handleZoom(event) {
    const maxZoom = 5;
    const sliderValue = event.target.value;
    const zoomLevel = sliderValue / maxZoom;
    const image = document.getElementById("map");
    image.style.transform = `scale(${zoomLevel})`;
    image.style.transition = `transform 400ms`;
  }

}
